import { render, staticRenderFns } from "./workOrderArchiving.vue?vue&type=template&id=6392b8d0&"
import script from "./workOrderArchiving.vue?vue&type=script&lang=js&"
export * from "./workOrderArchiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports